import {
  Component,
  Input,
  ViewChild,
  EventEmitter,
  Output,
  OnInit
} from '@angular/core';
import { cloneDeep, filter, get } from 'lodash';
import {
  IWizardContentComponent,
  IValueChangedEvent,
  IComponentStateHistory
} from '../../../wizard.content';
import { NgForm } from '@angular/forms';
import { REMOVED } from '../../../services/base.wizard.step';
import { EntityCacheProvider } from '@nrwl/common-lib';

@Component({
  selector: 'threshold-site-selection-html',
  templateUrl: './threshold.site.selection.page.html',
  providers: [],
  styleUrls: ['./threshold.site.selection.page.scss', '../../../wizard.button.style.scss']
})
export class ThresholdSiteSelectionComponent implements IWizardContentComponent, OnInit {
  @Input() step: any; //eslint-disable-line @typescript-eslint/no-explicit-any
  @Input() subStep: any; //eslint-disable-line @typescript-eslint/no-explicit-any
  @Input() wizardCtrl: any; //eslint-disable-line @typescript-eslint/no-explicit-any
  @Input() componentId: string;
  @Input() stateHistory?: IComponentStateHistory;
  // eslint-disable-next-line @angular-eslint/no-output-on-prefix
  @Output() onDataValueChange = new EventEmitter<IValueChangedEvent>();
  @ViewChild('currentForm', { static: true }) form: NgForm;

  siteList: any; //eslint-disable-line @typescript-eslint/no-explicit-any
  selectedSiteId: any; //eslint-disable-line @typescript-eslint/no-explicit-any
  selectedSiteCity: string;
  selectedSiteCountry: string;
  selectedSiteName: string;
  siteImg = 'images/site.svg';
  dataSource: any[]; //eslint-disable-line @typescript-eslint/no-explicit-any

  constructor(private readonly entityCache: EntityCacheProvider) {}

  ngOnInit() {
    this.step.form = this.form;
    this.getAllSites();
    this.selectedSiteId = 0;
    this.selectedSiteCity = '';
    this.selectedSiteCountry = '';
    this.selectedSiteName = '';
    this.repopulateSiteInfo();
  }

  getAllSites(): void {
    this.entityCache
      .findEntityCache('site')
      .getValuesAsync()
      .subscribe(sites => {
        const siteList = sites;
        this.dataSource = siteList.map(a => a.sitesData);
        this.dataSource = filter(this.dataSource, site => !site.deleted);
        this.dataSource = this.filterAvailableSite(this.dataSource);
        this.siteList = cloneDeep(this.dataSource);
      });
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
  filterAvailableSite(sites: any): any {
    let availableIds = this.step.parent.defaultParamsById.availableIds;
    const selectedAppId = this.step.parent.output['appId'];
    if (this.step.parent.defaultParamsById.dimensionValue === 'appSite') {
      availableIds = availableIds
        .filter(appSiteId => {
          return parseInt(appSiteId.split(',')[0], 10) === parseInt(selectedAppId, 10);
        })
        .map(appSiteIdString => Number(appSiteIdString.split(',')[1]));
    }
    return sites.filter(site => availableIds.indexOf(site.id) === -1);
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
  chooseSite(site: any): void {
    this.selectedSiteId = site.id;
    const city = get(site, 'location.city', '');
    const country = get(site, 'location.country', '');
    site.location = {
      city: city,
      country: country
    };
    this.selectedSiteCity = site.location.city;
    this.selectedSiteCountry = site.location.country;
    this.selectedSiteName = site.name;
    this.onDataValueChange.emit({
      componentId: this.componentId,
      inputId: 'siteInput',
      key: 'siteId',
      newValue: this.selectedSiteId,
      isValid: true
    });
    this.onDataValueChange.emit({
      componentId: this.componentId,
      inputId: 'cityInput',
      key: 'city',
      newValue: this.selectedSiteCity,
      isValid: true
    });
    this.onDataValueChange.emit({
      componentId: this.componentId,
      inputId: 'countryInput',
      key: 'country',
      newValue: this.selectedSiteCountry,
      isValid: true
    });
    this.onDataValueChange.emit({
      componentId: this.componentId,
      inputId: 'siteNameInput',
      key: 'siteName',
      newValue: this.selectedSiteName,
      isValid: true
    });
  }

  resetSelectedSiteInformation(): void {
    this.selectedSiteId = 0;
    this.selectedSiteCity = '';
    this.selectedSiteCountry = '';
    this.onDataValueChange.emit({
      componentId: this.componentId,
      inputId: 'siteInput',
      key: 'siteId',
      newValue: REMOVED,
      isValid: false
    });
    this.onDataValueChange.emit({
      componentId: this.componentId,
      inputId: 'cityInput',
      key: 'city',
      newValue: REMOVED,
      isValid: false
    });
    this.onDataValueChange.emit({
      componentId: this.componentId,
      inputId: 'countryInput',
      key: 'country',
      newValue: REMOVED,
      isValid: false
    });
    this.onDataValueChange.emit({
      componentId: this.componentId,
      inputId: 'siteNameInput',
      key: 'siteName',
      newValue: REMOVED,
      isValid: false
    });
  }

  repopulateSiteInfo(): void {
    const host = this.stateHistory(this.componentId, 'siteInput');
    if (host && host.value && host.value !== REMOVED) {
      this.selectedSiteId = host.value;
    }
    const city = this.stateHistory(this.componentId, 'cityInput');
    if (city && city.value && city.value !== REMOVED) {
      this.selectedSiteCity = city.value;
    }
    const country = this.stateHistory(this.componentId, 'countryInput');
    if (country && country.value && country.value !== REMOVED) {
      this.selectedSiteCountry = country.value;
    }
    const siteName = this.stateHistory(this.componentId, 'siteNameInput');
    if (siteName && siteName.value && siteName.value !== REMOVED) {
      this.selectedSiteName = siteName.value;
    }
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
  onSearchTextChange(searchText: any): any {
    searchText = searchText.toLowerCase();
    this.dataSource = filter(this.siteList, (item: any) => { //eslint-disable-line @typescript-eslint/no-explicit-any
      if (!item.location || !item.location.country) {
        item.location = { country: '' };
      }
      if (
        item.name.toLowerCase().indexOf(searchText) >= 0 ||
        item.location.country.toLowerCase().indexOf(searchText) >= 0
      ) {
        return item;
      }
    });
  }
}
